export namespace Themes {
  export const dark = 'dark';
  export const light = 'light';
}
